import {
  ActionSet,
  createActionSet,
  FUTRLI_MARKETING_SITE_URL
} from '@futrli/shared-services';

export const SIGN_IN: ActionSet = createActionSet('SIGN_IN');
export const SIGN_OUT: ActionSet = createActionSet('SIGN_OUT');
export const SIGN_IN_AND_CHECK: ActionSet = createActionSet('SIGN_IN_AND_CHECK');
export const CONFIRM_SIGN_IN: ActionSet = createActionSet('CONFIRM_SIGN_IN');

export const USER_NOT_CONFIRMED_EXCEPTION = 'UserNotConfirmedException';

export const JOIN_US_URL = `${FUTRLI_MARKETING_SITE_URL}which-futrli-product`;
